import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from 'rxjs/operators';
import { VinValidate } from "src/app/models/vin-validate/vin-validate";
import { VinValidateRequest } from "src/app/models/vin-validate/vin-validate-request";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: 'root'
})
export class VinValidateService {

    private apiUrl = environment.apiUrl;
    private vinValidateList: VinValidate[] = [];

    constructor(private httpClient: HttpClient) {
    }

    getVinValidate(country: string, vin: string, lang: string): Observable<VinValidate> {
      
      const request = new VinValidateRequest();
      request.country = country;
      request.vin = vin;
      request.language = lang;

      return this.httpClient.post<VinValidate>(`${this.apiUrl}/api/v2/vins/validate`, request)
        .pipe(
          map((response: VinValidate) => {
            return response;
          })
        );
    }

    setAllVinValidateList(validatedVins: VinValidate[]) {
      this.vinValidateList = validatedVins;
    }

    getAllVinValidateList(): VinValidate[] {
      return this.vinValidateList;
    }

    getAllVinValidateListClean() {
      this.vinValidateList = [];
    }
}
